<mat-toolbar class="confirm-header">
    <h5>
        {{title}}
      </h5>
</mat-toolbar>

<div class="confirm-body">

    <div class="row text-center confirm-content">
            <span>
                {{message}}
            </span>
            </div>
            <br>

        <div class="row text-center">

            <button mat-raised-button color="accent" (click)="dialogRef.close(true)">
                <span>OK</span>
            </button>

        </div>
</div>





// WEBPACK FOOTER //
// ./src/app/main/content/common/notify-popup/notify-popup.component.html